import { useEffect, useState } from "react";
type ToggleHandler = () => void;

const useConditionalOpen = (
  initialOpen: boolean,
  integrationIsSelectedToBePublished: boolean | undefined,
): [boolean, ToggleHandler] => {
  const [isOpen, setIsOpen] = useState(initialOpen);

  useEffect(() => {
    setIsOpen((prevOpen) => {
      if (prevOpen && !integrationIsSelectedToBePublished) {
        return false;
      }

      if (!prevOpen && integrationIsSelectedToBePublished) {
        return true;
      }

      return true;
    });
  }, [integrationIsSelectedToBePublished]);

  const handleToggle = () => {
    setIsOpen((prevOpen) => !prevOpen);
  };

  return [isOpen, handleToggle];
};

export default useConditionalOpen;
